import { CASH_FLOW_MODULE_URL } from "../../../constant/contact.module-config";

export const CASH_BOOK_MODULE_NAME = "Sổ quỹ";
export const CASH_BOOK_MODULE_URL = CASH_FLOW_MODULE_URL + "/cash-book";
export const CASH_BOOK__API_PATH = "/v1/cash-book";
